// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".connect-learn-page[data-v-4672280c]{min-height:100vh;padding-bottom:64px;background:linear-gradient(180deg, #fffafa 0%, #ffffff 36%, #ffffff 100%)}", ""]);
// Exports
module.exports = exports;
